import React from 'react';
import ServerService from '../../services/server.service';

class CloneStatus extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            instances: []
        }
    }

    componentDidMount() {
        this.setTestUsers()
    }

    setTestUsers() {
        ServerService.getCloneStatus().then(data=>{
            if (data && data.length > 0) {
                this.setState({ instances: data })
            } else {
                this.props.history.push('index')
            }
        })
    }

    render() {
        return (
            <div className="test_User">
                <h2>Test Users</h2>
                <table>
                            <tr>
                                <th>Instance Name</th>
                                <th>Status</th>
                            </tr>
                    {
                        this.state.instances.map((elem, i) =>
                            <tr key={i}>
                                <td>{elem.instanceName} </td>
                                <td>{elem.status} </td>
                            </tr>
                        )
                    }
                </table>
            </div>
        )
    }
}

export default CloneStatus;
